class PageDetail extends Component {
    constructor(el) {
        super(el);
        this.transformImagesIntoGallery();
    }

    transformImagesIntoGallery() {

        const inTextImages = [...document.querySelectorAll('picture')].reduce((acc, picture) => {
            if (!picture.parentElement.classList.length && picture.parentNode.tagName === 'A')
                acc.push(picture.parentElement)

            return acc
        },[])

        const gallery = document.querySelector('.ImageGallery');

        inTextImages.forEach( element => {
            element.classList.add('ImageGallery-item');
            element.dataset.lightgallery = `${gallery.dataset.galleryId}`;
            gallery.insertAdjacentElement('beforeend', element);
        });
    }
}